import React, { useEffect, useState } from "react";

import {  ContactInfo, ContactPhoneEmail, TitlePhoneEmail,  UserInfo,  UserInfoContact } from "../../../../components/ui/Content";

import {
    Body1PointerLink,
    ConfirmedText,
    TitleСontact
} from "../../../../components/Font";
import { useAppSelector } from "../../../../app/hooks";
import { ExternalAccount } from "../../../../interface/Passport/Account/frontend";

interface IProps {
    name: string, 
    connected: boolean
    url?: string | null
}

const AccountRow: React.FC<IProps> = ({name, connected, url}) => {
    const handleClick = (url: string) => {
        window.open(url, '_blank');
      };

    return (
        <ContactPhoneEmail>
            <ContactInfo>
                <TitlePhoneEmail>{name === 'Сбер ID' ? <img style={{width: '76px', position: 'relative', top: '2px'}} src="icons/sber_id.jpg" alt="" /> : name}</TitlePhoneEmail>
                {connected ? <ConfirmedText>подключена</ConfirmedText> : <ConfirmedText style={{color: 'black'}}>не подключена</ConfirmedText>}
            </ContactInfo>
            <Body1PointerLink
                style={{marginLeft: 'auto'}}
                className={'personalInfoChange'}
                onClick={() => handleClick(url ? url : '')}>
                {connected ? 'Изменить' : 'Подключить'}
            </Body1PointerLink>
        </ContactPhoneEmail>
    )
}

export const ExternalAccounts = () => {
    const { externalAccountsData } = useAppSelector(state => state.account)
    const [linkToSberID, setLinkToSberID] = useState()

    const data = externalAccountsData?.data

    useEffect(() => {
        const SberidSDK = window.SberidSDK
        const findSber = ({sber}: ExternalAccount) => sber
        const [sberData]: ExternalAccount[] = data?.filter(findSber) || [];
        const sber = sberData ? sberData.sber : null

        if (data?.length && sber) {

            const sberOptions = {
                oidc: sber,
            }
            if(location.hostname !== 'id.rudn.ru'){
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                sberOptions.baseUrl = "https://id-psi.sber.ru"
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            new SberidSDK(sberOptions)
                .init()
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                .then((sdk) => {
                    setLinkToSberID(sdk.getLink());
            });
        }
        }, [data])
            
    if (!data?.length) {
        return null
    }

    return (
        <UserInfo cursor="default">
            <UserInfoContact>
                <TitleСontact>Связать со Сбер ID</TitleСontact>
                {data?.map(({name, connected, url, sber}: ExternalAccount , index: number) => <AccountRow key={index} name={name} connected={connected} url={sber ? linkToSberID : url} />)}
            </UserInfoContact>
        </UserInfo>
    )
}
